import * as React from "react";
const SvgAlertCircle = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "alert-circle_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M11.983 0a12.2 12.2 0 0 0-8.51 3.653A11.8 11.8 0 0 0 0 12.207 11.78 11.78 0 0 0 11.8 24h.214A12.11 12.11 0 0 0 24 11.791 11.766 11.766 0 0 0 11.983 0M10.5 16.542a1.476 1.476 0 0 1 1.449-1.53h.027a1.527 1.527 0 0 1 1.523 1.47 1.475 1.475 0 0 1-1.449 1.53h-.027a1.53 1.53 0 0 1-1.523-1.47M11 12.5v-6a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0" }));
export { SvgAlertCircle as ReactComponent };
